import React from "react";
import PropTypes from "prop-types";
import i18n from "@/translate/i18n";

export function AmountInput({ value = "", currency = "", className }) {
  return (
    <div className={`flex flex-col w-full mb-8 text-left ${className}`}>
      <div className="flex gap-1 items-center justify-center h-10 bg-cripten-dark w-full px-5 rounded-full text-white">
        <span>{i18n.t("transactionDetails.depositAmount")}</span>
        <span className="text-cripten-primary">{value}</span>
        <span className="text-cripten-primary">{currency}</span>
      </div>
    </div>
  );
}

AmountInput.propTypes = {
  value: PropTypes.number,
  currency: PropTypes.string,
  className: PropTypes.string,
};
